import { Pipe, PipeTransform } from '@angular/core';
import { RpaDto } from '@flyfreely-portal-ui/flyfreely';
import {
    FormatDateTimePipe,
    FormatDurationPipe
} from '@flyfreely-portal-ui/ui';
import { FlightLogWithDuration } from './flight-log-list/flight-log-list-dialogue.component';
import { calculateLogDuration } from './helpers';

@Pipe({
    name: 'formatFlightLog'
})
export class FormatFlightLogPipe implements PipeTransform {
    constructor(
        private formatDateTime: FormatDateTimePipe,
        private formatDuration: FormatDurationPipe
    ) {}

    transform(
        flightLog: FlightLogWithDuration,
        rpa?: RpaDto | false,
        timeZone?: string
    ) {
        return `${rpa !== false ? this.formatName(flightLog, rpa) : ''}
        ${this.formatDateTime.transform(flightLog.summary?.startTime, timeZone)}
        <em> ${
            this.formatDuration.transform(calculateLogDuration(flightLog)) ?? ''
        }</em>`;
    }

    formatName(flightLog: FlightLogWithDuration, rpa?: RpaDto) {
        if (rpa == null) {
            return `<strong><em>Unassigned</em> (${flightLog.summary?.rpaName}) </strong>`;
        }
        return `<strong>${rpa.nickname} (${flightLog.summary?.rpaName}) </strong>`;
    }
}
